export default __webpack_public_path__ + "assets/models/7bb2ea1dd1696894d70090b00d12de95.glb";